import './people-slider.scss';
import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

// @ts-ignore
const SLIDES = window.BLOCK_PEOPLE_SLIDER || [];

type Selector = 'block' | 'media' | 'quote' | 'link' | 'playButton';

const selectors: Record<Selector, string> = {
  block: '[data-people-slider]',
  media: '[data-people-slider-media]',
  quote: '[data-people-slider-quote]',
  link: '[data-people-slider-link]',
  playButton: '[data-video-play]',
};

const elements: Record<Selector, null | HTMLElement> = {
  block: null,
  media: null,
  quote: null,
  link: null,
  playButton: null,
};

const classes: Record<'hidden', string> = {
  hidden: 'is-hidden',
};

function changeSlide({ realIndex }: { realIndex: number }) {
  if (!SLIDES.length) return null;

  const quote = SLIDES[realIndex].quote;
  const link = SLIDES[realIndex].link;
  const media = SLIDES[realIndex].media;
  const image = SLIDES[realIndex].image;
  const typeSlide = media?.type || 'image';

  elements.playButton?.classList.remove(classes.hidden);

  if (quote) {
    // @ts-ignore
    elements.quote.innerHTML = quote;
  }

  if (link) {
    elements.link?.classList.remove('hidden');
    elements.link?.setAttribute('href', link.url);

    const linkTitle = elements.link?.querySelector('span') as HTMLElement;
    linkTitle.innerText = link.title;
  } else {
    elements.link?.classList.add('hidden');
  }

  if (media || image) {
    elements.media?.setAttribute('data-people-slider-media', typeSlide);

    if (typeSlide === 'video') {
      const posterElement = elements.media?.querySelector(
        'video'
      ) as HTMLElement;
      const sourceElement = elements.media?.querySelector(
        'source'
      ) as HTMLElement;
      const posterPlyr = elements.media?.querySelector(
        '.plyr__poster'
      ) as HTMLElement;

      posterElement.setAttribute('data-poster', media.image.url || image.src);
      posterElement.setAttribute('src', media.source_url);
      posterPlyr?.setAttribute(
        'style',
        `background-image: url(${media.image.url || image.src})`
      );

      // @ts-ignore
      // posterElement.load();
    } else {
      const imageElement = elements.media?.querySelector('img') as HTMLElement;

      imageElement.setAttribute('src', media?.image.url || image.src);
    }
  }
}

const initSlider = () => {
  Swiper.use([Navigation, Pagination]);

  elements.block = document.querySelector(selectors.block) as HTMLElement;
  elements.media = document.querySelector(selectors.media) as HTMLElement;
  elements.quote = document.querySelector(selectors.quote) as HTMLElement;
  elements.link = document.querySelector(selectors.link) as HTMLElement;

  if (!elements.block) return null;

  elements.playButton = elements.block.querySelector(
    selectors.playButton
  ) as HTMLElement;

  new Swiper('.b-people-slider__swiper', {
    slidesPerView: 'auto',
    spaceBetween: 24,
    slideToClickedSlide: true,
    loop: true,

    navigation: {
      nextEl: '.b-people-slider__swiper .next',
      prevEl: '.b-people-slider__swiper .prev',
      disabledClass: 'disabled',
    },

    on: {
      activeIndexChange: changeSlide,
    },
  });
};

document.addEventListener(
  'DOMContentLoaded',
  async function () {
    initSlider();
  },
  { once: true }
);
